

<template>
  <div style="background:#f3f3f3;">
      <div class="wapper overf" >
	<div class="part">
       <img src="../../static/img/banner.png" width="100%"  />
	</div>
</div>

<div class="wapper overf">
	<div class="part main-box2" style="background:#fff; padding:50px;">
         <div class="tit3"><em><a @click="goHome()">返回首页>></a></em><span>查询结果</span></div>
        <div class="m_t_20 main-box" >
          <ul class="list16c">
              <li v-for="item in  list">
                  <span class="date">{{item.createTime}}</span>{{item.content}}
              </li>
          </ul>
		</div>
                

</div>
</div>



<div class="clear overf m_t_40"></div>
<!---- foot ---->
<div class="wapper overf p_b_10" style="background:#AD0C1D;" >
  <div class="part p_t_20 h26 cWhite f14 overf" >
	  <div class="t-center">	
              <p class=" p_l_10 ">
Copyright© 2010.中共湖南省委组织部举报中心 All Rights Reserved 
			  </p>
        <p class=" p_l_10 ">
    备案号：<a href="http://beian.miit.gov.cn/" target="_blank">湘ICP备17016663号-2</a>
                </p>
     </div>
</div>
</div>
  </div>
</template>

<script>
import request from '@/utils/request'
import { parseTime, formatTime } from '@/utils/index'
export default {
  data () {
    return {
        loginForm:{
            queryCode: '',
            code: '',
            uuid: '',
        },
        list: [],
      
    }
  },
  mounted(){
      this.loginForm.queryCode=this.$route.params.queryCode
      this.loginForm.code=this.$route.params.code
      this.loginForm.uuid=this.$route.params.uuid
      request({
              url: '/org-report/reply',
			        method: 'get',
              params: this.loginForm
            }).then((res)=>{
               this.list =res.data
                this.list = this.list.map(item => {
                        item.createTime = parseTime(item.createTime)
                        return item
                    })
            }).catch(err => {
                this.handleGetLoginCode()//更新uuid生产验证码
                alert(err.response.data.error)
             });
  },
  methods:{
      notice(code){
          this.$router.push({name:'notice',params:{areaCode:code}})
      },
      goHome(){
          this.$router.push({name:'index'})
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul.list16c { width:100%;  overflow:hidden; display:block; font-size:16px; margin:0 auto; font-family:microsoft yahei;   }
ul.list16c li {  margin:0px; padding:0px; overflow:hidden;  display:block; height:auto;  line-height:30px; color:#e00; padding-bottom:30px; border-bottom:1px dashed #ddd; margin:20px; background:#f5f5f5; padding:20px 50px; }
ul.list16c li span.date{ font-size:12px; color:#888;  padding-right:5px; display:block; height:30px; line-height:30px; }
</style>



// WEBPACK FOOTER //
// src/views/queryResult.vue